<template>
    <div id="app" v-stat="$stats.personalCenter.visit">
        <navigation></navigation>
        <header-component></header-component>
        <div id="content">
            <div class="container">
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive"/>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"/>
            </div>
            <footer-component></footer-component>
        </div>
        <aside-feedback></aside-feedback>
    </div>
</template>

<script>
import header from './components/common/header'
import navigation from './components/common/navigation'
import footer from './components/common/footer'
import asideFeedback from './components/common/asideFeedback'
import axios from 'axios'

export default {
    name: 'App',
    components: {
        'header-component': header,
        'navigation': navigation,
        'footer-component': footer,
        'aside-feedback': asideFeedback
    },
    created () {
        this.init()
    },
    methods: {
        init () {
            // 获取用户数据
            // this.getUserInfo()
        },
        getUserInfo () {
            let self = this
            axios.get('/developer/query')
                .then(response => {
                    let ret = response.data
                    if (ret.status_code === 0) {
                        self.$store.commit('userInfo/update', ret.result)
                    } else if (ret.status_code === -401) {
                    } else {
                        // self.$tip({
                        //     message: ret.status_msg ? ret.status_msg : '获取用户信息失败',
                        //     duration: 2000,
                        //     type: 'error'
                        // })
                        self.$message({
                            message: ret.status_msg ? ret.status_msg : '获取用户信息失败',
                            duration: 0,
                            type: 'error',
                            showClose: true
                        })
                    }
                })
                .catch(err => {
                    // self.$tip({
                    //     message: err.message ? err.message : '获取用户信息失败',
                    //     duration: 2000,
                    //     type: 'error'
                    // })
                    self.$message({
                        message: err.message ? err.message : '获取用户信息失败',
                        duration: 0,
                        type: 'error',
                        showClose: true
                    })
                })
        }
    }
}
</script>

<style lang="scss">
html, body {
    margin: 0;
    font-family: microsoft-YaHei;
    width: 100%;
    height: 100%;
}
#app {
    width: 100%;
    min-width: 1500px;
    height: 100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #f0f2f5;
    position: relative;
    #content {
        width: 100%;
        height: calc(100% - 64px);
        position: relative;
        overflow: auto;
        .container {
            height: calc(100% - 100px);
            min-height: 810px;
            margin-left: 256px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue